import { useTranslation } from 'react-i18next'
import PropTypes from 'prop-types'
import { DashboardBigCard } from '../components'
import { sum } from 'lodash'

export const AccreditationTotalBox = ({ accreditation }) => {
  const { t } = useTranslation()
  
  // Se controlan los porcentajes de acuerdo a los requisitos. Si el total de activos e inactivos es 0, se pone -1 para descartarlo.
  // si el 0 da producto de la división de 0 activos por una soma de activos e inactivos positiva, se pone 0 y entra en el cálculo
  const employeeAccreditationPercentage =
  ((accreditation.employees?.active || 0) + (accreditation.employees?.inactive || 0) > 0) ?
  (accreditation.employees?.percentage * 100 ?? 0) : -1 // if there are no employees, set percentage to -1 to discart it
  const contractAccreditationPercentage = 
    ((accreditation.contracts?.active || 0) + (accreditation.contracts?.inactive || 0) > 0) ?
    (accreditation.contracts?.percentage * 100 ?? 0) : -1
  const companyAccreditationPercentage =
    ((accreditation.companies?.active || 0) + (accreditation.companies?.inactive || 0) > 0) ?
    (accreditation.companies?.percentage * 100 ?? 0) : -1
  const assetAccreditationPercentage =
    ((accreditation.assets?.active || 0) + (accreditation.assets?.inactive || 0) > 0) ?
    (accreditation.assets?.percentage * 100 ?? 0) : -1

  const percentages = [
      employeeAccreditationPercentage,
      contractAccreditationPercentage,
      companyAccreditationPercentage,
      assetAccreditationPercentage
    ]
  const filteredPercentages = percentages.filter(percentage => percentage != -1);
  const total = sum(filteredPercentages) / filteredPercentages.length || 0;
    
  return (
    <DashboardBigCard
      title={t('dashboard.card.totalAccreditedPeople.title')}
      value={total.toFixed(1) || 0}
      tooltipTitle={t('dashboard.card.totalAccreditedPeople.tooltipTitle')}
      tooltipDescription={t(
        'dashboard.card.totalAccreditedPeople.tooltipDescription'
      )}
    />
  )
}

AccreditationTotalBox.propTypes = {
  accreditation: PropTypes.object.isRequired
}
